export default "__VITE_ASSET__BIU9g0J8__"